import React from 'react'
import { CountrySelectFieldProps } from './CountrySelectField.interface'
import { SelectField } from 'components/SelectField'
import {
  SS_COUNTRY_OPTIONS_LOGIN,
  SS_COUNTRY_OPTIONS_SIGN_UP_NO_SG,
  SS_COUNTRY_OPTIONS_SG_ONLY
} from './CountrySelectField.constants'

export const CountrySelectField = (props: CountrySelectFieldProps) => {
  const getOptions = () => {
    if (props.isSgOnly) {
      return SS_COUNTRY_OPTIONS_SG_ONLY
    }
    return props.isLogin ? SS_COUNTRY_OPTIONS_LOGIN : SS_COUNTRY_OPTIONS_SIGN_UP_NO_SG
  }

  return <SelectField {...props} by='value' options={getOptions()} />
}
